import { render } from "./vpulseicon.vue?vue&type=template&id=4e5ded6f"
const script = {}

import "./vpulseicon.vue?vue&type=style&index=0&id=4e5ded6f&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__